import { render } from "./MultipleSelect.vue?vue&type=template&id=2986a5d4&scoped=true"
import script from "./MultipleSelect.vue?vue&type=script&lang=js"
export * from "./MultipleSelect.vue?vue&type=script&lang=js"

import "./MultipleSelect.vue?vue&type=style&index=0&id=2986a5d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2986a5d4"]])

export default __exports__